module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-lgrey",
    class: {
      editing: _vm.currentIndex !== null
    },
    attrs: {
      "id": "objects"
    }
  }, [_c('tooltips', {
    attrs: {
      "tippy": _vm.tooltipsData,
      "box": _vm.tooltipsBox
    }
  }, [_c('room', {
    staticStyle: {
      "pointer-events": "none"
    },
    attrs: {
      "endline": "false"
    }
  }, [(_vm.tooltipsUpright) ? _c('k1wallupright', {
    attrs: {
      "data": _vm.tooltipsUpright,
      "show-edit": false,
      "is-selectable": true,
      "width": _vm.widths[_vm.tooltipsUpright.width],
      "height": _vm.heights[_vm.tooltipsUpright.height],
      "is-disabled": false,
      "show-add": false
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.currentIndex === null) ? _c('room', {
    attrs: {
      "endline": "false"
    }
  }, _vm._l((_vm.uprights), function(upright, index) {
    return _c('k1wallupright', {
      key: ("upright-" + index),
      attrs: {
        "data": upright,
        "width": _vm.widths[upright.width],
        "height": _vm.heights[upright.height],
        "is-disabled": _vm.currentIndex !== index && _vm.currentIndex !== null,
        "is-selectable": true,
        "is-selected": _vm.currentIndex === index
      },
      on: {
        "select": function($event) {
          _vm.editUpright(index)
        }
      }
    }, _vm._l((_vm.objects()[index]), function(object, obj_index) {
      return _c('k1element', {
        key: ("obj-" + index + "-" + obj_index),
        attrs: {
          "is-disabled": _vm.currentIndex === index,
          "selectable": false,
          "is-editing": _vm.currentModelObjectIndex === obj_index &&
            _vm.currentIndex === index,
          "pos-slot": object.slot,
          "img": _vm.objectRightWidth(object, index).frontal_inactive,
          "img-editing": _vm.objectRightWidth(object, index).frontal_active
        },
        on: {
          "click": function($event) {
            _vm.editObject(index, obj_index, object)
          }
        }
      })
    }))
  })) : _vm._e()], 1), _vm._v(" "), (_vm.currentIndex !== null) ? _c('k1walloverlay', {
    ref: "overlay",
    attrs: {
      "is-visible": _vm.currentIndex !== null,
      "index": _vm.currentIndex,
      "object-index": _vm.currentModelObjectIndex,
      "upright": _vm.uprights[_vm.currentIndex],
      "prev-upright": _vm.uprights[_vm.currentIndex - 1],
      "next-upright": _vm.uprights[_vm.currentIndex + 1]
    },
    on: {
      "editelement": _vm.editObject
    }
  }) : _vm._e(), _vm._v(" "), _c('elementsmenu', {
    attrs: {
      "configurator": _vm.configurator,
      "is-visible": _vm.currentIndex !== null,
      "elements": _vm.currentIndex !== null ? _vm.getObjectsWithRightWidth() : []
    },
    on: {
      "elementclick": _vm.addAndEditObject,
      "clone": _vm.cloneUpright,
      "confirm": _vm.closeMenu
    }
  }), _vm._v(" "), _c('editelementmenu', {
    ref: "editelementmenu",
    attrs: {
      "is-visible": _vm.currentModelObjectIndex !== null,
      "element": _vm.currentObject,
      "depths": _vm.getObjectDepths(_vm.currentObject, _vm.currentIndex) || [],
      "positions": _vm.availablePositions,
      "current-position": _vm.currentObjectPosition,
      "top-distance": _vm.currentModelObjectIndex !== null ? _vm.calcTopObjectHeight(_vm.currentModelObjectIndex) : 0
    },
    on: {
      "positionchange": _vm.onPositionChange,
      "selectdepth": _vm.selectDepth,
      "delete": function($event) {
        _vm.removeConfirmObject(_vm.currentModelObjectIndex)
      },
      "confirm": _vm.confirmObject
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8419ffe0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/objects/K1_wall.vue
// module id = 653
// module chunks = 0